import React from 'react'

import { Upload } from 'antd'
import { faLink } from '@fortawesome/pro-solid-svg-icons'
import { isFunction } from 'lodash'

import { isFileTooLarge, notifyFileTooLarge } from '../../../utils/files'
import { useSelector } from 'react-redux'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import TooltipIconButton from '../Buttons/TooltipIconButton'

const ButtonUploader = ({ className, files, text, title, onUpload, onRemove }) => {
  const t = useSelector(selectTranslate)

  const handleUpload = (file) => {
    if (isFunction(onUpload)) {
      if (isFileTooLarge(file)) {
        notifyFileTooLarge(file, t)
      } else {
        onUpload(file)
      }
    }

    return false
  }

  return (
    <Upload
      className={className}
      fileList={files}
      beforeUpload={handleUpload}
      onRemove={onRemove}
    >
      <TooltipIconButton icon={faLink} text={text} size='small' title={title} className={className} />
    </Upload>
  )
}

export default ButtonUploader
